import {Injectable} from '@angular/core';
import {LogoutStrategy} from './strategies/logout-strategy';
import {NativeLogoutStrategy} from './strategies/native-logout.strategy';
import {CustomerLogoutStrategy} from './strategies/customer-logout.strategy';
import {DefaultLogoutStrategy} from './strategies/default-logout.strategy';
import {UserType} from '../../../user';

@Injectable({
  providedIn: 'root',
})
export class LogoutStrategyResolverService {

  constructor(
    private readonly nativeLogoutStrategy: NativeLogoutStrategy,
    private readonly customerLogoutStrategy: CustomerLogoutStrategy,
    private readonly defaultLogoutStrategy: DefaultLogoutStrategy,
  ) {}

  resolve(userType: string): LogoutStrategy {
    switch (userType) {
      case UserType.NATIVE:
        return this.nativeLogoutStrategy;
      case UserType.CARC:
        return this.customerLogoutStrategy;
      default:
        return this.defaultLogoutStrategy;
    }
  }
}

